import { IRoleResponses } from 'types/roleMasterType';

const renderLevel = () => {
  const levels = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 10; i++) {
    // eslint-disable-next-line no-plusplus
    levels.push({ text: `${i} ${i === 0 ? '(強)' : ''} ${i === 9 ? '(弱)' : ''}`, value: `${i}` });
  }
  return levels;
};
export const LIST_AUTHORITY_LEVEL = renderLevel();

export const LIST_FEATURE_CATEGORY = [{ text: '基本マスター', value: '0' }, { text: '顧客管理', value: '1' }, { text: '予約', value: '2' }];


export const LIST_FEATURE_ROLE = {
  master: { text: '基本マスタ管理', value: '0' },
  customer: { text: '顧客管理', value: '1' },
  reservation: { text: '予約管理', value: '2' },
};

export const CODE_ADMIN = 3;
export const FOLLOW_ORG_ID = '';
export const CODE_EDIT = true;
export const CODE_IMPORT = true;
export const CODE_OUTPORT = true;
export const CODE_ISDISABLE = false;
export const CODE_MAILSEMD = true;
export const CODE_PDF = true;
export const CODE_MANAGERITEM = true;
export const CODE_EXCEL = true;
export const LIST_FEATURE_CODE_FULL_LEVEL:IRoleResponses[] = [];
